import { useGetDocumentPages } from 'entities/document/api';

export type UseDocumentPagesProps = {
  documentId?: number;
};

/**
 * Custom hook to working with document pages
 *
 * @param props - The properties for the hook, including the document ID.
 */
export const useDocumentPages = (props: UseDocumentPagesProps) => {
  /**
   * Hook to fetch a specific document by its ID.
   */
  const { data, isLoading, isInitialLoading, isFetching, refetch } =
    useGetDocumentPages(props.documentId);

  return {
    /**
     * The document pages fetched by the hook.
     */
    pages: data?.pages || [],

    /**
     * The total number of pages in the document.
     */
    totalPages: data?.totalPages || 0,

    /**
     * Boolean indicating if the document pages is initially loading.
     */
    isInitialLoading,

    /**
     * Boolean indicating if the document pages is currently being loaded.
     */
    isLoading,

    /**
     * Boolean indicating if the document pages is currently being fetched.
     */
    isFetching,

    /**
     * Function to refetch the document pages.
     */
    refetch,
  };
};
